"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));

var _LockBodyScroll = _interopRequireDefault(require("@paprika/helpers/lib/components/LockBodyScroll"));

var _Portal = _interopRequireDefault(require("@paprika/helpers/lib/components/Portal"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var sc = _interopRequireWildcard(require("./Overlay.styles"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var propTypes = {
  backdropClassName: _propTypes["default"].string,
  children: _propTypes["default"].func,

  /** container of the Overlay element */
  container: _propTypes["default"].instanceOf(Element),
  focusLockOptions: _propTypes["default"].shape({
    // properties copy from https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/src/Lock.js#L160
    // see description for props here: https://github.com/theKashey/react-focus-lock/blob/dee9b4c625eba0ca183fbda89005a5d09053086f/interfaces.d.ts#L4
    children: _propTypes["default"].node,
    disabled: _propTypes["default"].bool,
    returnFocus: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
    noFocusGuards: _propTypes["default"].bool,
    allowTextSelection: _propTypes["default"].bool,
    autoFocus: _propTypes["default"].bool,
    persistentFocus: _propTypes["default"].bool,
    group: _propTypes["default"].string,
    className: _propTypes["default"].string,
    whiteList: _propTypes["default"].func,
    shards: _propTypes["default"].arrayOf(_propTypes["default"].any),
    as: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
    lockProps: _propTypes["default"].object,
    onActivation: _propTypes["default"].func,
    onDeactivation: _propTypes["default"].func,
    sideCar: _propTypes["default"].any
  }),
  hasBackdrop: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func,
  onAfterOpen: _propTypes["default"].func,
  onAfterClose: _propTypes["default"].func,

  /** z-index of the Overlay wrapper */
  zIndex: _propTypes["default"].number
};
var defaultProps = {
  backdropClassName: null,
  children: function children() {},
  container: null,
  focusLockOptions: {},
  hasBackdrop: true,
  onAfterClose: function onAfterClose() {},
  onAfterOpen: function onAfterOpen() {},
  onClose: function onClose() {},
  zIndex: null
};

var Overlay = function Overlay(props) {
  var backdropClassName = props.backdropClassName,
      children = props.children,
      container = props.container,
      focusLockOptions = props.focusLockOptions,
      hasBackdrop = props.hasBackdrop,
      isOpen = props.isOpen,
      onAfterClose = props.onAfterClose,
      onAfterOpen = props.onAfterOpen,
      onClose = props.onClose,
      moreProps = (0, _objectWithoutProperties2["default"])(props, ["backdropClassName", "children", "container", "focusLockOptions", "hasBackdrop", "isOpen", "onAfterClose", "onAfterOpen", "onClose"]);

  function handleTransitionEnter(node) {
    // https://github.com/reactjs/react-transition-group/blob/6dbadb594c7c2a2f15bc47afc6b4374cfd73c7c0/src/CSSTransition.js#L44
    // eslint-disable-next-line no-unused-expressions
    node.scrollTop;
  }

  function handleEscKey(event) {
    if (event.key === "Escape" && isOpen) {
      event.stopPropagation();
      onClose();
    }
  }

  var _focusLockOptions = _objectSpread({
    returnFocus: true
  }, focusLockOptions);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isOpen && /*#__PURE__*/_react["default"].createElement(_LockBodyScroll["default"], null), /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
    container: container
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    mountOnEnter: true,
    unmountOnExit: true,
    "in": isOpen,
    timeout: +_tokens["default"].overlay.animationDuration,
    onEnter: handleTransitionEnter,
    onEntered: onAfterOpen,
    onExited: onAfterClose
  }, function (state) {
    return /*#__PURE__*/_react["default"].createElement(sc.Overlay, (0, _extends2["default"])({
      "data-pka-anchor": "overlay"
    }, moreProps, {
      onKeyDown: handleEscKey
    }), hasBackdrop && /*#__PURE__*/_react["default"].createElement(sc.Backdrop, {
      className: backdropClassName,
      state: state,
      onClick: onClose,
      "data-pka-anchor": "overlay.backdrop"
    }), /*#__PURE__*/_react["default"].createElement(_reactFocusLock["default"], (0, _extends2["default"])({
      disabled: state === "exiting" || state === "exited"
    }, _focusLockOptions), children && children(state)));
  })));
};

Overlay.displayName = "Overlay";
Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
var _default = Overlay;
exports["default"] = _default;
//# sourceMappingURL=Overlay.js.map